import { Type } from "class-transformer";
import ResponseEntity from "../../..";
import {
  IsString,
  IsInt,
  ValidateNested,
  ValidateIf,
  IsBoolean,
} from "class-validator";
import TransmedAnnouncement from "./announcement";
import OutputTransmedForm from "../form";
import TransmedRanking from "./ranking";
import TransmedDistribution from "./distribution";
import TransmedCertificate from "./certificate";

export default class OutputTransmedProcess extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @IsString() public readonly regulations!: string;
  @IsString() public readonly participation_proof_template!: string;
  @IsString() public readonly period_text!: string;
  @IsBoolean() public readonly expired!: boolean;
  @IsBoolean() public readonly transmedAvailable!: boolean;

  @ValidateIf((obj) => obj.announcement !== null)
  @Type(() => TransmedAnnouncement)
  @ValidateNested()
  public readonly announcement!: TransmedAnnouncement | null;

  @ValidateIf((obj) => obj.form !== null)
  @Type(() => OutputTransmedForm)
  @ValidateNested()
  public readonly form!: OutputTransmedForm | null;

  @ValidateIf((obj) => obj.ranking !== null)
  @Type(() => TransmedRanking)
  @ValidateNested()
  public readonly ranking!: TransmedRanking | null;

  @ValidateIf((obj) => obj.distribution !== null)
  @Type(() => TransmedDistribution)
  @ValidateNested()
  public readonly distribution!: TransmedDistribution | null;

  @ValidateIf((obj) => obj.certificate !== null)
  @Type(() => TransmedCertificate)
  @ValidateNested()
  public readonly certificate!: TransmedCertificate | null;
}
